"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Dropdown = _interopRequireDefault(require("react-bootstrap/Dropdown"));
var _Nav = _interopRequireDefault(require("react-bootstrap/Nav"));
var _Navbar = _interopRequireDefault(require("react-bootstrap/Navbar"));
var _link = require("../link");
var _SecondTierMegaNavColumn = _interopRequireDefault(require("./SecondTierMegaNavColumn"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const MegaNavText = _ref => {
  let {
    label
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Navbar.default.Text, null, label);
};
MegaNavText.displayName = 'MegaNav.Text';
MegaNavText.propTypes = {
  label: _propTypes.default.string.isRequired
};
const MegaNavLink = _ref2 => {
  let {
    label,
    link
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(_Nav.default.Item, null, /*#__PURE__*/_react.default.createElement(_Nav.default.Link, {
    href: (0, _link.absolute)(link)
  }, label));
};
MegaNavLink.displayName = 'MegaNav.Link';
MegaNavLink.propTypes = {
  label: _propTypes.default.string.isRequired,
  link: _propTypes.default.any.isRequired
};

/*
 * This CustomMenu component exists solely because the `popperConfig` options
 * that _could_ be used _won't_ work. To reposition the Overlay with the menu,
 * the style has to be applied on an inner element, since the outer element
 * always has 0 margin added by the react-bootstrap library.
 */
const MegaNavCustomMenu = /*#__PURE__*/_react.default.forwardRef((_ref3, ref) => {
  let {
    children,
    className,
    'aria-labelledby': labelledBy
  } = _ref3;
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: ref
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: className,
    "aria-labelledby": labelledBy
  }, children));
});
MegaNavCustomMenu.displayName = 'MegaNav.CustomMenu';
MegaNavCustomMenu.propTypes = {
  'aria-labelledby': _propTypes.default.string,
  children: _propTypes.default.node.isRequired,
  className: _propTypes.default.string
};
const MegaNavDropdown = _ref4 => {
  let {
    label,
    navColumns,
    isHomepage
  } = _ref4;
  // This is used to look through all of the MageNav columns and if any contain a header link
  // (and not a section header) then the space will be added at the top of each column
  // to match spacing across all columns.
  // ie. if one header link exists, the other columns should add extra white space
  let headerCheck = false;
  navColumns.forEach(column => {
    // columns can be either navItems or navImage
    if (column.navItems) {
      if (column.navItems[0].itemType !== 'sectionheader') {
        headerCheck = true;
      }
    }
  });
  return /*#__PURE__*/_react.default.createElement(_Dropdown.default, {
    as: _Nav.default.Item,
    className: `${headerCheck ? '' : 'no-column-headers'} `
  }, /*#__PURE__*/_react.default.createElement(_Dropdown.default.Toggle, {
    bsPrefix: "dropdown-toggle",
    childBsPrefix: "nav-link",
    id: `${label.replace(' ', '-')}-menu`,
    variant: "",
    className: `${isHomepage ? 'homepage' : ''}`
  }, ' ', label, ' '), /*#__PURE__*/_react.default.createElement(_Dropdown.default.Menu, {
    renderOnMount: true,
    as: MegaNavCustomMenu
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row no-gutters"
  }, navColumns.map((navColumn, idx) => /*#__PURE__*/_react.default.createElement(_SecondTierMegaNavColumn.default, _extends({
    key: `stmnc-${idx}`
  }, navColumn))))));
};
MegaNavDropdown.displayName = 'MegaNav.Dropdown';
MegaNavDropdown.propTypes = {
  isHomepage: _propTypes.default.bool,
  label: _propTypes.default.string,
  navColumns: _propTypes.default.any
};
MegaNavDropdown.defaultProps = {
  isHomepage: false
};
const MegaNav = _ref5 => {
  let {
    trunk
  } = _ref5;
  const homepage = trunk?.navheader?.navSettings?.brandDisplayText === '';
  if (!trunk?.navheader?.megaNav || trunk.navheader.megaNav.length === 0) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_Nav.default, {
    className: "primary"
  }, trunk?.navheader?.megaNav?.map((item, index) => {
    let Component;
    let isHomepage = false;
    if (item.link) {
      Component = MegaNav.Link;
    } else if (item.navColumns) {
      isHomepage = index === 0 && homepage;
      Component = MegaNav.Dropdown;
    } else {
      Component = MegaNav.Text;
    }
    return /*#__PURE__*/_react.default.createElement(Component, _extends({
      key: item.label
    }, item, {
      isHomepage: isHomepage
    }));
  }));
};
MegaNav.propTypes = {
  trunk: _propTypes.default.any
};
MegaNav.Text = MegaNavText;
MegaNav.Link = MegaNavLink;
MegaNav.Dropdown = MegaNavDropdown;
var _default = exports.default = MegaNav;